if (!customElements.get('checkbox-group')) {
  customElements.define(
    'checkbox-group',
    class CheckboxGroup extends HTMLElement {
      constructor() {
        super()
        this.group = this.querySelector('[data-checkbox-group]')
        this.checkboxes = this.querySelectorAll('[data-checkbox]')
        this.showSource = this.dataset.showSource
        this.sourceUrl = this.dataset.sourceUrl
        this.form = this.closest('form')
        this.submitBtn = this.form.querySelector('input[type="submit"]')
        this.submitBtn.addEventListener('click', (e) => this.isValid(e))
        this.onChange()
        this.onKeydown()
      }
      onKeydown() {
        this.addEventListener('keydown', (e) => {
          const key = e.key
          if (key === 'Enter' && e.target.tagName === 'LABEL') {
            const checkbox = e.target.parentNode.querySelector('input')
            if (checkbox.checked === false) {
              checkbox.checked = true
            } else {
              checkbox.checked = false
            }
          }
        })
      }
      onChange() {
        const arr = []
        if (this.showSource === 'true') {
          arr.push(this.sourceUrl)
        }
        this.checkboxes.forEach((checkbox) => {
          checkbox.addEventListener('change', () => {
            if (checkbox.checked === true) {
              arr.push(checkbox.value)
              this.removeError()
            } else {
              const index = arr.indexOf(checkbox.value)
              if (index !== -1) {
                arr.splice(index, 1)
              }
            }
            this.group.value = arr.toString()
          })
        })
      }
      removeError() {
        if (this.group.classList.contains('required')) {
          this.submitBtn.removeAttribute('disabled')
        } else {
          this.group.classList.add('required')
        }
        this.checkboxes.forEach((checkbox) =>
          checkbox.classList.remove('error')
        )
      }
      isValid(e) {
        if (
          this.group.classList.contains('required') &&
          this.group.value === ''
        ) {
          e.preventDefault()
          this.checkboxes.forEach((checkbox) => {
            checkbox.classList.add('error')
          })
        }
      }
    }
  )
}
